import ReactDOM from 'react-dom';
import { FriendGroupWithMembers } from '../../../../types';

interface AddToGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
  groups: FriendGroupWithMembers[];
  selectedGroupsForFriend: number[];
  onToggleGroupSelection: (groupId: number) => void;
  onAddFriendToGroups: () => void;
  loading: boolean;
  t: (key: string, params?: any) => string;
}

/**
 * Modal for adding a friend to multiple groups
 */
export const AddToGroupModal: React.FC<AddToGroupModalProps> = ({
  isOpen,
  onClose,
  groups,
  selectedGroupsForFriend,
  onToggleGroupSelection,
  onAddFriendToGroups,
  loading,
  t,
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal-overlay" style={{ zIndex: 99999 }} onClick={onClose}>
      <div className="modal-content-groups" style={{ zIndex: 100000 }} onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ✕
        </button>
        <h2>{t('map.groups.addToGroups')}</h2>
        <div className="groups-selection">
          {groups.length === 0 ? (
            <p className="empty-message">{t('map.groups.noGroupsYet')}</p>
          ) : (
            groups.map((group) => (
              <div
                key={group.id}
                className={`group-select-card ${selectedGroupsForFriend.includes(group.id) ? 'selected' : ''}`}
                onClick={() => onToggleGroupSelection(group.id)}
              >
                <input
                  type="checkbox"
                  checked={selectedGroupsForFriend.includes(group.id)}
                  onChange={() => onToggleGroupSelection(group.id)}
                  onClick={(e) => e.stopPropagation()}
                />
                <span
                  className="group-color-indicator"
                  style={{ backgroundColor: group.color }}
                ></span>
                <span>{group.name}</span>
              </div>
            ))
          )}
        </div>
        <div className="modal-actions-groups">
          <button
            className="btn-primary"
            onClick={onAddFriendToGroups}
            disabled={loading || selectedGroupsForFriend.length === 0}
          >
            {loading ? t('map.groups.adding') : t('map.groups.addToCount', { count: selectedGroupsForFriend.length })}
          </button>
          <button
            className="btn-secondary"
            onClick={onClose}
            disabled={loading}
          >
            {t('common.cancel')}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
